/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-11-29 10:14:05
 * @LastEditors: yy
 * @LastEditTime: 2021-05-26 16:47:52
 */

function cutstr(str, rowLen, row) {
  let str_length = 0;
  let str_len = str.length;
  let str_cut = new String();

  for (let i = 0; i < str_len; i++) {
    const char = str.charAt(i);
    const nextChar = str.charAt(i + 1)
    str_length++;

    if (escape(char).length > 4) {
      //中文字符的长度经编码之后大于4
      str_length++;
    }

    str_cut = str_cut.concat(char);

    if (str_length> 0) {
      // 如果整除增加换行
      if (str_length % rowLen === 0) {
        str_cut = str_cut.concat('\n')
      }
      // 还差一个字符换行的时候，
      // 根据下一个字符是否为中文字符，
      // 如果中文字符则换行
      if ((str_length % rowLen >= rowLen - 1 && escape(char).length > 4)) {
        str_cut = str_cut.concat('\n')
      }
    }

    if (str_length >= rowLen * row - 4) {
      str_cut = str_cut.concat("...");
      return str_cut
    }
  }
  //如果字符串长度小于需要裁切的长度，直接返回
  if (str_length < rowLen) {
    return str;
  }else {
    console.log(str_cut);
    
    return str_cut
  }
}

export default (G6) => {
  // @ts-ignore
  G6.registerNode('node-des', {
    options: {
      style: {

      },
      stateStyles: {
        hover: {},
        selected: {},
      },
    },
    draw(cfg, group) {
      const BASE_PADDING = 15
      const size = cfg.size || [40, 40]
      const width = size[0]
      const height = size[1]
      const startX = 0 - width / 2
      const startY = 0 - height / 2

      // 如果 cfg 中定义了 style 需要同这里的属性进行融合
      const shape = group.addShape('rect', {
        attrs: {
          x: startX,
          y: startY,
          width,
          height,
          fill: '#fff',
          stroke: cfg.color || 'red',
          radius: 3,
          cursor: 'pointer',
          shadowColor: 'rgba(0,0,0,.3)',
          shadowBlur: 6,
          shadowOffsetX: 1,
          shadowOffsetY: 1
        },
      });

      if (cfg.plat) {
        group.addShape('text', {
          attrs: {
            x: startX + BASE_PADDING,
            y: startY + BASE_PADDING,
            textAlign: 'start',
            textBaseline: 'top',
            text: cfg.plat,
            fill: '#000',
            fontSize: 14,
            fontWeight: 600
          },
        })
      }

      if (cfg.title) {
        group.addShape('text', {
          // attrs: style
          attrs: {
            x: startX + BASE_PADDING, // 居中
            y: 0,
            textAlign: 'start',
            textBaseline: 'middle',
            // text: setText(cfg.title),
            text: cutstr(cfg.title, 34, 3),
            fill: '#2e2e2e',
          },
        });
      }


      if (cfg.key_info) {
        group.addShape('text', {
          attrs: {
            x: startX + BASE_PADDING,
            y: (height - BASE_PADDING) / 2,
            textAlign: 'start',
            textBaseline: 'bottom',
            text: cfg.key_info + '：' + cfg.key_num,
            fill: '#aaaaaa',
            fontSize: 12,
          },
        })
      }

      return shape;
    }
  })

  // @ts-ignore
  G6.registerNode('node-image', {
    options: {
      style: {},
      stateStyles: {
        hover: {},
        selected: {},
      },
    },
    draw(cfg, group) {
      const BASE_PADDING = 15
      const size = cfg.size || [40, 40]
      const width = size[0]
      const height = size[1]
      const startX = 0 - width / 2
      const startY = 0 - height / 2

      // 如果 cfg 中定义了 style 需要同这里的属性进行融合
      const shape = group.addShape('rect', {
        attrs: {
          x: startX,
          y: startY,
          width,
          height,
          fill: '#fff',
          stroke: cfg.color || 'red',
          radius: 3,
          cursor: 'pointer',
          shadowColor: 'rgba(0,0,0,.3)',
          shadowBlur: 6,
          shadowOffsetX: 1,
          shadowOffsetY: 1
        },
      });
      group.addShape('text', {
        attrs: {
          x: startX + BASE_PADDING,
          y: startY + BASE_PADDING,
          textAlign: 'start',
          textBaseline: 'top',
          text: '微博',
          fill: '#000',
          fontSize: 14,
          fontWeight: 600
        },
      })
      group.addShape('text', {
        attrs: {
          x: startX + BASE_PADDING,
          y: (height - BASE_PADDING) / 2,
          textAlign: 'start',
          textBaseline: 'bottom',
          text: '相似文章数：20',
          fill: '#6c6c6b',
          fontSize: 14,
        },
      })
      group.addShape('text', {
        // attrs: style
        attrs: {
          x: startX + BASE_PADDING, // 居中
          y: 0,
          textAlign: 'start',
          textBaseline: 'middle',
          text: '《“5G小儿科AI大产业”\n华为海思任重道远》',
          fill: '#666',
        },
      });
      return shape;
    }
  })

  /******************************************* */
  // @ts-ignore
  G6.registerNode('node-user', {
    options: {
      style: {},
      stateStyles: {
        hover: {},
        selected: {},
      },
    },
    draw(cfg, group) {
      const BASE_PADDING = 15
      const size = cfg.size || [40, 40]
      const width = size[0]
      const height = size[1]
      const startX = 0 - width / 2
      const startY = 0 - height / 2

      // 如果 cfg 中定义了 style 需要同这里的属性进行融合
      const shape = group.addShape('rect', {
        attrs: {
          x: startX,
          y: startY,
          width,
          height,
          fill: '#fff7d2',
          stroke: cfg.color,
          radius: 3,
          cursor: 'pointer',
        },
      });

      if (cfg.author_name) {
        group.addShape('text', {
          attrs: {
            x: 0,
            y: startY + BASE_PADDING,
            textAlign: 'center',
            textBaseline: 'top',
            text: cfg.author_name,
            fill: '#2e2e2e',
            fontSize: 14,
            fontWeight: 600
          },
        })
      }

      if (cfg.title) {
        group.addShape('text', {
          attrs: {
            x: 0,
            y: (height - BASE_PADDING) / 2,
            textAlign: 'center',
            textBaseline: 'bottom',
            text: cfg.title,
            fill: '#949494',
            fontSize: 12
          }
        })
      }

      return shape;
    }
  })

  // @ts-ignore
  G6.registerNode('node-media', {
    options: {
      style: {},
      stateStyles: {
        hover: {},
        selected: {},
      },
    },
    draw(cfg, group) {
      const BASE_PADDING = 15
      const size = cfg.size || [40, 40]
      const width = size[0]
      const height = size[1]
      const startX = 0 - width / 2
      const startY = 0 - height / 2

      // 如果 cfg 中定义了 style 需要同这里的属性进行融合
      const shape = group.addShape('rect', {
        attrs: {
          x: startX,
          y: startY,
          width,
          height,
          fill: '#fff',
          stroke: cfg.color || 'red',
          radius: 3,
          cursor: 'pointer',
          shadowColor: 'rgba(0,0,0,.3)',
          shadowBlur: 6,
          shadowOffsetX: 1,
          shadowOffsetY: 1
        },
      });


      if (cfg.plat) {
        const x = /微信|微博|知乎/g.test(cfg.plat) ? startX + BASE_PADDING : startX + BASE_PADDING + 50

        group.addShape('text', {
          attrs: {
            x: x,
            y: startY + BASE_PADDING + 10,
            textAlign: 'start',
            textBaseline: 'top',
            text: cfg.plat,
            fill: '#000',
            fontSize: 14,
            fontWeight: 600
          },
        })
      }

      if (cfg.fans_count) {
        group.addShape('text', {
          attrs: {
            x: width / 2 - BASE_PADDING,
            y: startY + BASE_PADDING + 10,
            textAlign: 'end',
            textBaseline: 'top',
            text: '粉丝数：' + cfg.fans_count,
            fill: '#aaaaaa',
            fontSize: 12,
          },
        })
      }





      if (cfg.logo) {
        const iconPos = {
          x: startX + BASE_PADDING + 40,
          y: startY + BASE_PADDING - 8,
        }

        iconPos.x = /微信|微博|知乎/g.test(cfg.plat) ? (startX + BASE_PADDING + cfg.plat.length * 15 + 5) : startX + BASE_PADDING

        // @ts-ignore
        const clipShape = new G6.G.Circle({
          attrs: {
            r: 22.5,
            x: iconPos.x + 22.5,
            y: iconPos.y + 22.5,
          }
        });

        const img = group.addShape('image', {
          attrs: {
            x: startX + BASE_PADDING + 40,
            y: startY + BASE_PADDING - 8,
            width: 45,
            height: 45,
            img: cfg.logo,
            ...iconPos
          }
        });
        img.attr('clip', clipShape)

        if (cfg.is_v) {
          group.addShape('circle', {
            attrs: {
              x: iconPos.x + 40,
              y: iconPos.y + 40,
              r: 7,
              fill: '#fef2bf',
              stroke: '#ff7520',

            },
          })
          group.addShape('text', {
            attrs: {
              x: iconPos.x + 40,
              y: iconPos.y + 42,
              fill: '#ff7520',
              textAlign: 'center',
              textBaseline: 'middle',
              text: 'V',
              fontSize: 12,
            },
          })
        }
      }

      if (cfg.key_info && cfg.key_num) {
        group.addShape('text', {
          attrs: {
            x: startX + BASE_PADDING,
            y: (height - BASE_PADDING) / 2,
            textAlign: 'start',
            textBaseline: 'bottom',
            text: cfg.key_info + '：' + cfg.key_num,
            fill: '#aaaaaa',
            fontSize: 12,
          }
        })
      }

      if (cfg.key_info_1 && cfg.key_num_1) {
        group.addShape('text', {
          attrs: {
            x: width / 2 - BASE_PADDING,
            y: (height - BASE_PADDING) / 2,
            textAlign: 'end',
            textBaseline: 'bottom',
            text: cfg.key_info_1 + '：' + cfg.key_num_1,
            fill: '#aaaaaa',
            fontSize: 12,
          }
        })
      }


      if (cfg.title) {
        group.addShape('text', {
          attrs: {
            x: startX + BASE_PADDING, // 居中
            y: 10,
            textAlign: 'start',
            textBaseline: 'middle',
            // text: setText(cfg.title),
            text: cutstr(cfg.title, 34, 3),
            fill: '#2e2e2e',
            lineWeight: 180
          },
        });
      }

      return shape;
    }
  })

  // 自定义图标
  // @ts-ignore
  G6.registerNode('node-icon', {
    options: {
      style: {},
      stateStyles: {
        hover: {},
        selected: {},
      },
    },
    draw(cfg, group) {
      const size = cfg.size || [40, 40]
      const width = size[0]
      const height = size[1]
      const startX = -width / 2
      const startY = -height / 2

      // 如果 cfg 中定义了 style 需要同这里的属性进行融合
      const shape = group.addShape('circle', {
        attrs: {
          x: startX,
          y: startY,
          r: width / 2,
          fill: '#fff7d2'
        },
      });

      

      if (cfg.img) {
        const clipShape = new G6.G.Circle({
          attrs: {
            r: width / 2,
            x: startX,
            y: startY
          }
        });

        const img = group.addShape('image', {
          attrs: {
            x: -width,
            y: -height,
            width: width,
            height: height,
            img: cfg.img,
          }
        });
        img.attr('clip', clipShape)
      }

      return shape;
    }
  })
}




// WEBPACK FOOTER //
// src/routes/customChart/KeyMediaGraph/customNode.js